// extracted by mini-css-extract-plugin
export default {"tag":"dark_tag__UMX9r undefined"};